import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'
export function getCompanyUserUpdateRecord(params) {
  return request({
    url: '/GetCompanyUserUpdateRecord',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 301,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        KeyWord: params.keyWord,
        SortOrder: params.SortOrder
      }
    }
  })
}

export function updateCompanyUserRecordState(params) {
  return request({
    url: '/UpdateCompanyUserRecordState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 301,
      MessageID: btcguid(),
      Data: {
        UpdateID: params.UpdateID,
        Status: params.status
      }
    }
  })
}

export function getCompanyUser(params) {
  return request({
    url: '/GetCompanyUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 301,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        KeyWord: params.keyWord,
        IsExport: params.IsExport,
        Country: params.country,
        SortOrder: params.SortOrder,
        CompanyProvince: params.CompanyProvince,
        LastCRMUpdateTime: params.LastCRMUpdateTime
      }
    }
  })
}

export function addCompanyUser(params) {
  return request({
    url: '/AddCompanyUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 302,
      MessageID: btcguid(),
      Data: {
        // Company
        LoginUserName: params.LoginUserName,
        CompanyName: params.CompanyName,
        CompanyLocalName: params.CompanyLocalName,
        CompanyEmail: params.CompanyEmail,
        CompanyType: params.CompanyType,
        // ProductType: params.ProductType,
        CompanyRegTime: params.CompanyRegTime,
        CompanyPhoneNumber: params.CompanyPhoneNumber,
        CompanyFaxNumber: params.CompanyFaxNumber,
        CompanyWebSite: params.CompanyWebSite,
        CompanyCountry: params.CompanyCountry,
        CompanyProvince: params.CompanyProvince,
        CompanyAddress: params.CompanyAddress,
        Status: params.Status,
        RegesterIpAddress: params.RegesterIpAddress,
        UpdateTime: params.UpdateTime,
        // Contact
        ContactPersonName: params.ContactPersonName,
        ContactPersonEnglishName: params.ContactPersonEnglishName,
        ContactPersonSex: params.ContactPersonSex,
        ContactPersonCellPhoneNumber: params.ContactPersonCellPhoneNumber
      }
    }
  })
}

export function updateCompanyUser(params) {
  return request({
    url: '/UpdateCompanyUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 303,
      MessageID: btcguid(),
      Data: {
        // Company
        CompanyID: params.CompanyID,
        LoginUserName: params.LoginUserName,
        CompanyName: params.CompanyName,
        CompanyLocalName: params.CompanyLocalName,
        CompanyEmail: params.CompanyEmail,
        CompanyType: params.CompanyType,
        ProductType: params.ProductType,
        CompanyRegTime: params.CompanyRegTime,
        CompanyPhoneNumber: params.CompanyPhoneNumber,
        CompanyFaxNumber: params.CompanyFaxNumber,
        CompanyWebSite: params.CompanyWebSite,
        CompanyCountry: params.CompanyCountry,
        CompanyProvince: params.CompanyProvince,
        CompanyAddress: params.CompanyAddress,
        Status: params.Status,
        RegesterIpAddress: params.RegesterIpAddress,
        UpdateTime: params.UpdateTime,
        CompanyAttribute: params.CompanyAttribute,
        MemberType: params.MemberType,
        // Contact
        ContactPersonID: params.ContactPersonID,
        ContactPersonName: params.ContactPersonName,
        ContactPersonEnglishName: params.ContactPersonEnglishName,
        ContactPersonSex: params.ContactPersonSex,
        ContactPersonCellPhoneNumber: params.ContactPersonCellPhoneNumber
      }
    }
  })
}

export function deleteCompanyUser(params) {
  return request({
    url: '/DeleteCompanyUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 304,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID
      }
    }
  })
}

export function getCompanyCrm(params) {
  return request({
    url: '/GetCompanyCrm',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 305,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID
      }
    }
  })
}

export function addCompanyCrm(params) {
  return request({
    url: '/AddCompanyCrm',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 306,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID,
        CompanyType: params.CompanyType,
        HasQualification: params.HasQualification,
        HasImportsAndExportsDate: params.HasImportsAndExportsDate,
        RegisterUserDutie: params.RegisterUserDutie,
        RelatedPlaceOfProduction: params.RelatedPlaceOfProduction,
        PhoneNumber: params.PhoneNumber,
        WeiXinNumber: params.WeiXinNumber,
        CustomerAppraise: params.CustomerAppraise,
        CompanyName: params.CompanyName,
        Province: params.Province,
        RoleInBtc: params.RoleInBtc,
        ContactPerson: params.ContactPerson
      }
    }
  })
}

export function updateCompanyCrm(params) {
  return request({
    url: '/UpdateCompanyCrm',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 307,
      MessageID: btcguid(),
      Data: {
        CompanyCrmID: params.CompanyCrmID,
        CompanyType: params.CompanyType,
        HasQualification: params.HasQualification,
        HasImportsAndExportsDate: params.HasImportsAndExportsDate,
        RegisterUserDutie: params.RegisterUserDutie,
        RelatedPlaceOfProduction: params.RelatedPlaceOfProduction,
        PhoneNumber: params.PhoneNumber,
        WeiXinNumber: params.WeiXinNumber,
        CustomerAppraise: params.CustomerAppraise,
        CompanyName: params.CompanyName,
        Province: params.Province,
        RoleInBtc: params.RoleInBtc,
        ContactPerson: params.ContactPerson
      }
    }
  })
}

export function getCompanyContactDetail(params) {
  return request({
    url: '/GetCompanyContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 308,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        CompanyID: params.companyID
      }
    }
  })
}

export function addCompanyContactDetail(params) {
  return request({
    url: '/AddCompanyContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 309,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID,
        ContactDateTime: params.ContactDateTime,
        ContactPerson: params.ContactPerson,
        ContactWay: params.ContactWay,
        ContactContent: params.ContactContent,
        ContactKey: params.ContactKey,
        ContactLevel: params.ContactLevel
        // CanModify: params.CanModify
      }
    }
  })
}

export function addPriceDataOpinionContactDetail(params) {
  return request({
    url: '/AddPriceDataOpinionContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 309,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID,
        ContactDateTime: params.ContactDateTime,
        ContactPerson: params.ContactPerson,
        ContactWay: params.ContactWay,
        ContactContent: params.ContactContent,
        ContactKey: params.ContactKey,
        ContactLevel: params.ContactLevel,
        PriceDataOpinionID: params.PriceDataOpinionID
        // CanModify: params.CanModify
      }
    }
  })
}

export function updatePriceDataOpinionContactDetail(params) {
  return request({
    url: '/UpdatePriceDataOpinionContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 309,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID,
        ContactDateTime: params.ContactDateTime,
        ContactPerson: params.ContactPerson,
        ContactWay: params.ContactWay,
        ContactContent: params.ContactContent,
        ContactKey: params.ContactKey,
        ContactLevel: params.ContactLevel,
        PriceDataOpinionID: params.PriceDataOpinionID
        // CanModify: params.CanModify
      }
    }
  })
}

export function updateCompanyContactDetail(params) {
  return request({
    url: '/UpdateCompanyContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 311,
      MessageID: btcguid(),
      Data: {
        ContactID: params.ContactID,
        CompanyID: params.CompanyID,
        ContactDateTime: params.ContactDateTime,
        ContactPerson: params.ContactPerson,
        ContactWay: params.ContactWay,
        ContactContent: params.ContactContent,
        ContactKey: params.ContactKey,
        ContactLevel: params.ContactLevel,
        CanModify: params.CanModify,
        PriceDataOpinionID: params.PriceDataOpinionID
      }
    }
  })
}

export function getCompanyUserProfile(userID) {
  return request({
    url: '/GetCompanyUserProfile',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 311,
      MessageID: btcguid(),
      Data: {
        UserID: userID
      }
    }
  })
}

export function updateCompanyUserProfile(params) {
  return request({
    url: '/UpdateCompanyUserProfile',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 312,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        IsPi: params.IsPi,
        PiExpireDate: params.PiExpireDate,
        ChargeState: params.ChargeState,
        GradeMoney: params.GradeMoney,
        CanVisitModule: params.CanVisitModule,
        ChargeExpireDate: params.ChargeExpireDate,
        LastChargeAmount: params.LastChargeAmount,
        ViewNewsNumber: params.ViewNewsNumber,
        ViewNewsIDs: params.ViewNewsIDs,
        LastChargeDate: params.LastChargeDate,
        ChargeStataEn: params.ChargeStataEn,
        CanVisitModuleEn: params.CanVisitModuleEn,
        ChargeEnExpireDate: params.ChargeEnExpireDate,
        LastChangeAmountEn: params.LastChangeAmountEn,
        ViewNewsNumberEn: params.ViewNewsNumberEn,
        ViewNewsIDsEn: params.ViewNewsIDsEn,
        LastChargeEnDate: params.LastChargeEnDate,
        ViewSmartPushNumber: params.ViewSmartPushNumber,
        IsEndOfTrial: params.IsEndOfTrial,
        IsEndOfTrialEn: params.IsEndOfTrialEn,
        ViewEnEmailsNumber: params.ViewEnEmailsNumber,
        ViewImporterNumber: params.ViewImporterNumber,
        Handlers: params.Handlers,
        ApiCode: params.ApiCode,
        ApiCount: params.ApiCount
      }
    }
  })
}

export function getUserMemberRequest(params) {
  return request({
    url: '/GetUserMemberRequest',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 313,
      MessageID: btcguid(),
      Data: {
        PageSize: params.PageSize,
        PageNum: params.PageNum,
        isCnRequire: params.isCnRequire,
        isEnRequire: params.isEnRequire,
        IsExport: params.IsExport,
        KeyWord: params.keyWord,
        RequireLevel: params.RequireLevel,
        RequireType: params.RequireType
      }
    }
  })
}

export function getMembershipList(params) {
  return request({
    url: '/GetMembershipList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 314,
      MessageID: btcguid(),
      Data: {
        PageSize: params.PageSize,
        PageNum: params.PageNum,
        Type: params.Type,
        Keyword: params.keyword,
        IsExport: params.IsExport
      }
    }
  })
}

export function getUserLoginInfo(params) {
  return request({
    url: '/GetUserLoginInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 315,
      MessageID: btcguid(),
      Data: {
        PageSize: params.PageSize,
        PageNum: params.PageNum,
        TimeRanges: params.TimeRanges,
        Keyword: params.keyWord,
        IsApp: params.IsApp,
        StartDate: params.StartDate,
        EndDate: params.EndDate
      }
    }
  })
}

export function getUserLoginGroupInfo(params) {
  return request({
    url: '/GetUserLoginGroupInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 316,
      MessageID: btcguid(),
      Data: {
        PageSize: params.PageSize,
        PageNum: params.PageNum,
        Keyword: params.Keyword
      }
    }
  })
}

export function getCompanyProfile(params) {
  return request({
    url: '/GetCompanyProfile',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 317,
      MessageID: btcguid(),
      Data: {
        PageSize: params.PageSize,
        PageNum: params.PageNum,
        keyWords: params.keyWords,
        Country: params.Country,
        Province: params.Province
      }
    }
  })
}

export function addCompanyProfile(params) {
  return request({
    url: '/AddCompanyProfile',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 318,
      MessageID: btcguid(),
      Data: {
        CompanyName: params.CompanyName,
        MemberLevel: params.MemberLevel,
        JoinDate: params.JoinDate,
        ExpireDate: params.ExpireDate,
        OrderID: params.OrderID,
        Country: params.Country,
        Province: params.Province
      }
    }
  })
}

export function updateCompanyProfile(params) {
  return request({
    url: '/UpdateCompanyProfile',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 319,
      MessageID: btcguid(),
      Data: {
        CompanyProfileID: params.CompanyProfileID,
        CompanyName: params.CompanyName,
        MemberLevel: params.MemberLevel,
        JoinDate: params.JoinDate,
        ExpireDate: params.ExpireDate,
        OrderID: params.OrderID,
        Country: params.Country,
        Province: params.Province
      }
    }
  })
}

export function getCompanyBaseInfo(params) {
  return request({
    url: '/GetCompanyBaseInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 320,
      MessageID: btcguid(),
      Data: {
        CompanyProfileID: params.CompanyProfileID
      }
    }
  })
}

export function addCompanyBaseInfo(params) {
  return request({
    url: '/AddCompanyBaseInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 321,
      MessageID: btcguid(),
      Data: {
        CompanyProfileID: params.CompanyProfileID,
        CompanyName: params.CompanyName,
        IsImportQualification: params.IsImportQualification,
        Imports: params.Imports,
        CompanyNature: params.CompanyNature,
        EnterpriseNature: params.EnterpriseNature,
        Website: params.Website,
        License: params.License,
        Other: params.Other,
        BtcRepresentative: params.BtcRepresentative
      }
    }
  })
}

export function updateCompanyBaseInfo(params) {
  return request({
    url: '/UpdateCompanyBaseInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 322,
      MessageID: btcguid(),
      Data: {
        CompanyProfileID: params.CompanyProfileID,
        CompanyName: params.CompanyName,
        IsImportQualification: params.IsImportQualification,
        Imports: params.Imports,
        CompanyNature: params.CompanyNature,
        EnterpriseNature: params.EnterpriseNature,
        Website: params.Website,
        License: params.License,
        Other: params.Other,
        BtcRepresentative: params.BtcRepresentative
      }
    }
  })
}

export function getCompanyMemberInfo(params) {
  return request({
    url: '/GetCompanyMemberInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 323,
      MessageID: btcguid(),
      Data: {
        PageSize: params.PageSize,
        PageNum: params.PageNum,
        CompanyProfileID: params.CompanyProfileID
      }
    }
  })
}

export function addCompanyMemberInfo(params) {
  return request({
    url: '/AddCompanyMemberInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 324,
      MessageID: btcguid(),
      Data: {
        CompanyProfileID: params.CompanyProfileID,
        MemberRepresentative: params.MemberRepresentative,
        LoginUserName: params.LoginUserName,
        Position: params.Position,
        Phone: params.Phone,
        CompanyPhone: params.CompanyPhone,
        Email: params.Email,
        Wechat: params.Wechat,
        Skype: params.Skype,
        Other: params.Other,
        BusinessCard: params.BusinessCard,
        OrderID: params.OrderID
      }
    }
  })
}

export function updateCompanyMemberInfo(params) {
  return request({
    url: '/UpdateCompanyMemberInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 325,
      MessageID: btcguid(),
      Data: {
        CompanyMemberInfoID: params.CompanyMemberInfoID,
        MemberRepresentative: params.MemberRepresentative,
        LoginUserName: params.LoginUserName,
        Position: params.Position,
        Phone: params.Phone,
        CompanyPhone: params.CompanyPhone,
        Email: params.Email,
        Wechat: params.Wechat,
        Skype: params.Skype,
        Other: params.Other,
        BusinessCard: params.BusinessCard,
        OrderID: params.OrderID
      }
    }
  })
}

export function getCompanyMemberInfoDetail(params) {
  return request({
    url: '/GetCompanyMemberInfoDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 326,
      MessageID: btcguid(),
      Data: {
        CompanyMemberInfoID: params.CompanyMemberInfoID
      }
    }
  })
}

export function deleteCompanyProfile(params) {
  return request({
    url: '/DeleteCompanyProfile',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 327,
      MessageID: btcguid(),
      Data: {
        CompanyProfileID: params.CompanyProfileID
      }
    }
  })
}

export function deleteCompanyMemberInfo(params) {
  return request({
    url: '/DeleteCompanyMemberInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 328,
      MessageID: btcguid(),
      Data: {
        CompanyMemberInfoID: params.CompanyMemberInfoID
      }
    }
  })
}

export function getUserInfoByID(companyid) {
  return request({
    url: '/GetUserInfoByID',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 329,
      MessageID: btcguid(),
      Data: {
        CompanyID: companyid
      }
    }
  })
}

export function getCrmList(params) {
  return request({
    url: '/GetCrmList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 330,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        IsExport: params.IsExport,
        Keyword: params.Keyword
      }
    }
  })
}

export function getCompanyContact(ContactID) {
  return request({
    url: '/GetCompanyContact',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 331,
      MessageID: btcguid(),
      Data: {
        ContactID: ContactID
      }
    }
  })
}

export function exportBtcMembership(country) {
  return request({
    url: '/ExportBtcMembership',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 332,
      MessageID: btcguid(),
      Data: {
        Country: country
      }
    }
  })
}

export function getNextContactInfo(params) {
  return request({
    url: '/GetNextContactInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 333,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        SortOrder: params.SortOrder,
        SortField: params.SortField,
        CompanyID: params.CompanyID
      }
    }
  })
}

export function addNextContactInfo(params) {
  return request({
    url: '/AddNextContactInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 334,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        ContactTime: params.ContactTime,
        Note: params.Note,
        CompanyID: params.CompanyID
      }
    }
  })
}

export function updateNextContactInfo(params) {
  return request({
    url: '/UpdateNextContactInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 335,
      MessageID: btcguid(),
      Data: {
        NextContactID: params.NextContactID,
        UserID: params.UserID,
        ContactTime: params.ContactTime,
        Note: params.Note,
        FollowUpNote: params.FollowUpNote,
        CompanyID: params.CompanyID
      }
    }
  })
}

export function getCompanyUserByContactTime(params) {
  return request({
    url: '/GetCompanyUserByContactTime',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 336,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        UserID: params.UserID,
        ContactTime: params.ContactTime
      }
    }
  })
}

export function updateContactMark(params) {
  return request({
    url: '/UpdateContactMark',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 337,
      MessageID: btcguid(),
      Data: {
        ContactID: params.ContactID,
        Mark: params.Mark
      }
    }
  })
}

export function getLoginInfoByIp(params) {
  return request({
    url: '/GetLoginInfoByIp',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 338,
      MessageID: btcguid(),
      Data: {
        LoginIpAddress: params.LoginIpAddress
      }
    }
  })
}

export function getLoginInfoByID(params) {
  return request({
    url: '/GetLoginInfoByID',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 339,
      MessageID: btcguid(),
      Data: {
        UserName: params.UserName
      }
    }
  })
}

export function updateUserActivity(UserID) {
  return request({
    url: '/UpdateUserActivity',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 340,
      MessageID: btcguid(),
      Data: {
        UserID: UserID
      }
    }
  })
}

export function UpdateCompanyUserFollowUpState(params) {
  return request({
    url: '/UpdateCompanyUserFollowUpState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 340,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID,
        IsFollowUp: params.IsFollowUp
      }
    }
  })
}
export function updateUserDeleteState(params) {
  return request({
    url: '/UpdateUserDeleteState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 349,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID
      }
    }
  })
}

export function getMembershipNew(params) {
  return request({
    url: '/GetMembershipNew',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 341,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        KeyWord: params.keyWord,
        IsExport: params.IsExport,
        Country: params.country,
        SortOrder: params.SortOrder,
        CompanyProvince: params.CompanyProvince,
        LastCRMUpdateTime: params.LastCRMUpdateTime
      }
    }
  })
}

export function getCircleTourist(params) {
  return request({
    url: '/GetCircleTourist',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 342,
      MessageID: btcguid(),
      Data: {
        PageSize: params.PageSize,
        PageNum: params.PageNum,
        Keyword: params.Keyword
      }
    }
  })
}

export function getCircleMember(params) {
  return request({
    url: '/GetCircleMember',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 343,
      MessageID: btcguid(),
      Data: {
        PageSize: params.PageSize,
        PageNum: params.PageNum,
        Keyword: params.Keyword
      }
    }
  })
}

export function getCompanyPrivacy(params) {
  return request({
    url: '/GetCompanyPrivacy',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 344,
      MessageID: btcguid(),
      Data: {
        PageSize: params.PageSize,
        PageNum: params.PageNum,
        UserName: params.UserName
      }
    }
  })
}

export function deleteCompanyPrivacy(params) {
  return request({
    url: '/DeleteCompanyPrivacy',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 345,
      MessageID: btcguid(),
      Data: {
        ID: params.ID
      }
    }
  })
}

export function setSalesMan(params) {
  return request({
    url: '/SetSalesMan',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 346,
      MessageID: btcguid(),
      Data: {
        CompanyIDs: params.CompanyIDs,
        SalesMan: params.SalesMan
      }
    }
  })
}

export function getSystemUser() {
  return request({
    url: '/GetSystemUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 347,
      MessageID: btcguid(),
      Data: {}
    }
  })
}

export function getCompanySalesUser(params) {
  console.log(params)
  return request({
    url: '/GetCompanySalesUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 348,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        KeyWord: params.keyWord,
        IsExport: params.IsExport,
        Country: params.country,
        SortOrder: params.SortOrder,
        CompanyProvince: params.CompanyProvince,
        LastCRMUpdateTime: params.LastCRMUpdateTime
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/company.js